import PropTypes from 'prop-types';
import PasswordChangeViewImpl from './password-change-view.js';
import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;

/**
 * A view responsible for rendering the user interface for password change.
 *
 * @class PasswordChangeView
 * @private
 * @memberof Mojito.Modules.PasswordChange
 */

/**
 * `PasswordChangeView` prop types.
 *
 * @property {string} [passwordChangeState] - Represents the current state of password change.
 *
 * @memberof Mojito.Modules.PasswordChange.PasswordChangeView
 */
const propTypes = {
    passwordChangeState: PropTypes.string,
};

export default UIView('PasswordChangeView', PasswordChangeViewImpl, propTypes);
